import { format } from "date-fns";

const mutations = {
    setProducts(state, products) {
        state.productList = products;
    },
    setProductUnits(state, units) {
        state.productUnits = units;
    },
    setProductPriceTypes(state, priceTypes) {
        state.productPriceTypes = priceTypes;
    },
    setProductData(state, product) {
        state.product = product;
    },
    setProductUnit(state,data){
        state.productUnit = data;
    },
    setDefaultProductPriceType(state,data) {
        state.product.prices[0].productPriceTypeId = data;
    },
    resetProductUnit(state){
        state.productUnit = {
            label : '',
            code : ''
        }
    },
    resetProduct(state) {
        state.product = {
            name: '',
            purchasePrice: '',
            taxId: '',
            unitId: '',
            minimumQuantity: 1,
            hsn: '',
            barcode: '',
            isDisabled: false,
            quantity: 0,
            prices: [
              {
                startDate: format(new Date(), "YYYY-MM-DD"),
                price: 0,
                fromQuantity: 1,
                defaultDiscount : 0
              }
            ],
            productAttributes: [
              {
                attributeId: '',
                value: ''
              }
            ],
            metadata : {
                rackNumber : '',
                branch_price: ''
            }
        }
    },
    setBarcode(state,data) {
        state.barcode = data;
    }
    
}

export default mutations;